import React from 'react';
import pinkSrc from '../assets/key-tag-pink.svg';
import greenSrc from '../assets/key-tag-green.svg';

export type KeyTagVariant = 'pink' | 'green';
type KeyTagSize = 'xl' | 'md' | 'sm';

interface KeyTagProps {
  number?: number;
  courtNumber?: number; // alias
  variant?: KeyTagVariant;
  size?: KeyTagSize;
  hero?: boolean;  // treated same as size="xl"
  label?: string;
}

const SIZES: Record<KeyTagSize, { width: number; height: number }> = {
  xl: { width: 160, height: 245 },
  md: { width: 80,  height: 122 },
  sm: { width: 52,  height: 80  },
};

// Number overlay settings per size — coordinates in SVG viewBox space (0 0 1024 1568)
const NUMBER_Y: Record<KeyTagSize, number> = {
  xl: 161,
  md: 161,
  sm: 161,
};

const NUMBER_FONT: Record<KeyTagSize, number> = {
  xl: 26,
  md: 26,
  sm: 26,
};

export const KeyTag: React.FC<KeyTagProps> = ({
  number,
  courtNumber,
  variant = 'pink',
  size = 'md',
  hero = false,
  label,
}) => {
  const courtNum = number ?? courtNumber ?? 1;
  const effectiveSize: KeyTagSize = hero ? 'xl' : (size as KeyTagSize);
  const { width, height } = SIZES[effectiveSize] ?? SIZES['md'];
  const src = variant === 'pink' ? pinkSrc : greenSrc;
  const numStr = String(courtNum).padStart(2, '0');
  const ariaLabel = label ?? `Court ${courtNum} key tag`;

  return (
    <div
      role="img"
      aria-label={ariaLabel}
      style={{ position: 'relative', width, height, flexShrink: 0 }}
    >
      <img
        src={src}
        alt=""
        aria-hidden="true"
        style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
      />

    </div>
  );
};

export default KeyTag;
